__turbopack_context__.v({
  "container": "style-module__8mCggq__container",
  "content": "style-module__8mCggq__content",
  "contentOne": "style-module__8mCggq__contentOne",
  "contentTwo": "style-module__8mCggq__contentTwo",
  "heading": "style-module__8mCggq__heading",
});
